module.exports = __webpack_public_path__ + "images/emoji/white_square_button.f688ad7dec37027b925a.png";